import {observer} from "mobx-react-lite";
import RuleGroup from "../../store/entities/rules/RuleGroup";
import {Fields, FieldsGroup} from "../../lib/wa-2.0";
import React from "react";
import {RuleComponent} from "./RuleComponent";
import ImageSettingsRules from "../../store/entities/rules/ImageSettingsRules";
import "./destination.sass"

export const RulesGroupComponent = observer((
    {group, category_id, updateAttributes, saveGroup}:
        {
            group: RuleGroup,
            category_id?: string,
            updateAttributes?: ()=>void
            saveGroup?: (group: RuleGroup|null) => void
        }) => {


    return <div>
        <h6 className={"custom-mt-32"}>{group.group_name}</h6>
        {category_id && updateAttributes && <button
            className="button blue update-attributes"
            onClick={updateAttributes}
        >
            Обновить список характеристик
        </button>}
        {category_id && saveGroup &&<button
            className={"button green ozon_save"}
            onClick={()=>saveGroup(group)}
        >Сохранить</button>}

        <Fields>
            <FieldsGroup>
                {group.rules.map((rule, index) => {
                    if (rule instanceof ImageSettingsRules) {
                        return <div key={index + rule.type}>
                            {rule.child_rules.map((imageRule, index) =>
                                <RuleComponent
                                    rule={imageRule}
                                    key={index + imageRule.type}
                                    onMouseEnterInput={() => {
                                        rule.callInputLoadExampleValue()
                                    }}
                                />)}
                        </div>
                    }
                    return <RuleComponent
                        key={index + rule.type}
                        rule={rule}
                        onMouseEnterInput={() => {
                            rule.callInputLoadExampleValue()
                        }}
                    />
                })}
            </FieldsGroup>
        </Fields>
        {category_id && saveGroup && <button
            className={"button green ozon_save"}
            onClick={()=>saveGroup(group)}
        >Сохранить</button>}
    </div>
})